import React, { memo } from 'react';

function BrandRadarLoading() {
  return (
    <div className="BrandRadar-loading">
      <div className="BrandRadar-loading-spinner" />
      <span>Loading brand network...</span>
    </div>
  );
}

export default memo(BrandRadarLoading);
